import { DialogController } from 'aurelia-dialog';
import { EntityController} from 'pages/entity/entity-controller';
import { autoinject } from 'aurelia-framework';
import { Item } from 'data/entities/entities';
import { ItemDataService } from "data/service/item-data-service";

@autoinject()
export class EditKanbanDialog {

    item: Item;

    constructor(
        private dialogController: DialogController,
        private controller: EntityController,
        private itemDataService: ItemDataService) {
        this.dialogController.settings.lock = true;
    }

    activate(item:Item) {
        this.item = item;
    }
    cancelEdit()
    {
        this.itemDataService.rejectChanges(this.item);
        this.dialogController.cancel();
    }

    saveEdit() {
        this.controller.addRelatedItems(this.item);
        this.item.save();
        this.dialogController.ok();
    }

}